module.exports = __webpack_public_path__ + "img/VE.9b9ffd3f.svg";